import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	UsSurgingPetitionToastExperiment,
	UsSurgingPetitionToastPetition as UsSurgingPetitionToastPetitionQ,
} from './api.graphql';
import type {
	UsSurgingPetitionToastExperimentQuery,
	UsSurgingPetitionToastExperimentQueryVariables,
	UsSurgingPetitionToastPetitionQuery,
	UsSurgingPetitionToastPetitionQueryVariables,
} from './api.graphql';

type UsSurgingPetitionToastExperimentAssignment =
	UsSurgingPetitionToastExperimentQuery['experiments']['usSurgingPetitionToast'];

export type UsSurgingPetitionToastPetition = NonNullable<UsSurgingPetitionToastPetitionQuery['petition']>;

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export const US_SURGING_PETITION_TOAST_EXPERIMENT_QUERY_KEY = 'US_SURGING_PETITION_TOAST_EXPERIMENT';
export const US_SURGING_PETITION_TOAST_PETITION_QUERY_KEY = 'US_SURGING_PETITION_TOAST_PETITION';

export async function fetchUsSurgingPetitionToastExperiment(
	utilityContext: UtilityContext,
): Promise<UsSurgingPetitionToastExperimentAssignment> {
	const {
		gql: { fetch },
	} = utilityContext;
	const { data } = await fetch<UsSurgingPetitionToastExperimentQuery, UsSurgingPetitionToastExperimentQueryVariables>({
		query: UsSurgingPetitionToastExperiment,
		rejectOnError: true,
	});

	return data.experiments.usSurgingPetitionToast;
}

export async function fetchUsSurgingPetitionToastPetition(
	utilityContext: UtilityContext,
	{ slug }: { slug: string },
): Promise<UsSurgingPetitionToastPetition | null> {
	const {
		gql: { fetch },
	} = utilityContext;
	// Trailing 1-day window for the momentum stat, computed at fetch time (per spec).
	const createdAfter = new Date(Date.now() - ONE_DAY_IN_MS).toISOString();
	const { data } = await fetch<UsSurgingPetitionToastPetitionQuery, UsSurgingPetitionToastPetitionQueryVariables>({
		query: UsSurgingPetitionToastPetitionQ,
		variables: { slug, createdAfter },
		rejectOnError: true,
	});

	return data.petition ?? null;
}
